import { render, staticRenderFns } from "./RefCab.vue?vue&type=template&id=3ca41d23&scoped=true"
import script from "./RefCab.vue?vue&type=script&lang=js"
export * from "./RefCab.vue?vue&type=script&lang=js"
import style0 from "./RefCab.vue?vue&type=style&index=0&id=3ca41d23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca41d23",
  null
  
)

export default component.exports